import moment from 'moment';
export default {
	/*
	addListSaveRows_: function (state) {
		return state.variableManagements.filter(el => el.tableState === 'I' || el.tableState === 'U');
	},
	*/
	getSearchDates_({ searchParams: { startDt, endDt } }) {
		return [moment(startDt).format('YYYY-MM-DD'), moment(endDt).format('YYYY-MM-DD')];
	},
	totalSize_: state => {
		const { totalSize } = state.pagingInfo;
		return totalSize;
	},

	pageUnit_: state => {
		const { pageUnit } = state.pagingInfo;
		return pageUnit;
	}
};
